export { default } from './RehabActionList.component';
